import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import {
  getRequestInAssets as getRequest,
  postRequestInAssets as postRequest,
  putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import { useHistory } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Master from "../Master";
import jwt_decode from "jwt-decode";
import notificationService from "services/notification.service";
import moment from "moment";
import TimePicker from "components/TimePicker";
import { days } from "components/common/Constants";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

var id = undefined;
var action = "Submit";
var title = "Add Site";
var view = undefined;
var onlyView = false;
var zoneId = undefined;
var enterprise = "";
var utcTime;

function AddSiteForm(props) {
  id = props.match.params.id;
  zoneId = props.match.params.zoneId;
  view = props.match.params.view;

  const initialFormValues = {
    externalId: "",
    shortSiteName: "",
    siteName: "",
    zipCode: "",
    longitude: "",
    country: "",
    countryId: 1,
    state: "",
    stateId: -1,
    city: "",
    cityId: -1,
    addressLine1: "",
    addressLine2: "",
    username: "",
    latitude: "",
    siteStatus: "",
    zone: "",
    swapStations: "",
    commissionedOn: "",
    createdAt: "",
    contactNumber: "",
    zoneEnterprise: "",
    openingTime: null,
    closingTime: null,
    workingDays: [],
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  //const [zones, setZones] = useState([{ id: "", name: "" }]);

  const [zoneList, setZoneList] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [country, setCountry] = useState([]);
  const [zoneEnterprise, setZoneEnterprise] = useState("");
  const [updateState, setUpdateState] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updateCountry, setUpdateCountry] = useState("");
  const history = useHistory();

  const [updateSiteId, setUpdateSiteId] = useState("");
  const getCountryData = [
    {
      id: 1,
      name: "India",
      stateId: 1,
    },
  ];

  const getZones = useCallback(async (string) => {
    await getRequest("zone/getZoneInfo")
      .then((res) => {
        if (res.data != null) {
          setZoneList(res?.data?.zoneList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getCountryList = useCallback(async () => {
    await getRequest("getCountries")
      .then((res) => {
        if (res.data != null) {
          setCountry(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const getStateList = useCallback(async (id) => {
    await getRequest("getStates?countryId=" + id)
      .then((res) => {
        if (res.data != null) {
          setState(res.data);
        }
        if (res.data.length == 0) {
          setCity([]);
          setFormValues((data) => ({
            ...data,
            stateId: -1,
            countryId: -1,
            cityId: -1,
          }));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  const getCitList = useCallback(async (id) => {
    await getRequest("getCities?stateId=" + id)
      .then((res) => {
        if (res.data != null) {
          setCity(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    // getCountryList();
    getStateList(1);
  }, []);

  useEffect(() => {
    getZones();
  }, [getZones]);
  const getSiteDataByID = useCallback(async (id, zoneId) => {
    await getRequest(
      `bss/site/SiteInformation?enterprise=${zoneId}&siteId=${id}`
    )
      .then((res) => {
        if (res.data != null) {
          setUpdateSiteId(res.data.id);
          patchForm(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    enterprise = decodedToken.group[0];
    getCountryList();
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Site";
      onlyView = false;
      getSiteDataByID(id, zoneId);
    } else if (id !== undefined && view !== undefined) {
      action = "View";
      title = "View Site";
      onlyView = true;
      getSiteDataByID(id, zoneId);
    } else {
      action = "Submit";
      title = "Add Site";
      onlyView = false;
    }
  }, []);

  const patchForm = (data) => {
    if (data?.countryId) {
      setUpdateCountry(data.country);
      getStateList(data?.countryId);
    }
    if (data?.stateId) {
      setUpdateState(data.state);
      setUpdateCity(data.city);
      getCitList(data?.stateId);
    }
    const openingTime = data.openingTime
      ? moment()
          .hours(data.openingTime.split(":")[0])
          .minute(data.openingTime.split(":")[1])
      : null;
    const closingTime = data.closingTime
      ? moment()
          .hours(data.closingTime.split(":")[0])
          .minute(data.closingTime.split(":")[1])
      : null;
    setFormValues({
      ...formValues,
      externalId: data.externalId,
      shortSiteName: data.shortSiteName,
      siteName: data.name,
      contactNumber: data.contactPersonNumber,
      commissionedOn: data.commissionedOn
        ? new Date(data.commissionedOn)
        : null,
      latitude: data.latitude,
      longitude: data.logitude,
      siteStatus: data.status,
      zone: data.zoneId,
      swapStations: data.numberOfSwapStations,
      createdAt: new Date(data.createdAt),
      username: data.contactPersonName,
      addressLine1: data.address1,
      addressLine2: data.address2,
      country: data.country,
      countryId: data.countryId,
      state: data.state,
      stateId: data.stateId,
      city: data.city,
      cityId: data.cityId,
      zipCode: data.pinCode,
      openingTime: openingTime,
      closingTime: closingTime,
      workingDays: data.workingDays,
    });
  };

  const handleTime = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const handleWorkingDays = (day) => {
    let updateDays = formValues.workingDays ? formValues.workingDays : [];
    if (updateDays.includes(day)) {
      updateDays.splice(updateDays.indexOf(day), 1);
    } else {
      updateDays.push(day);
    }
    setFormValues({ ...formValues, workingDays: updateDays.sort() });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "externalId") {
      if (value.length > 20) {
          const truncatedValue = value.slice(0, 20);
          setFormValues({ ...formValues, [name]: truncatedValue });
          return;
      }
  }

    setFormValues({ ...formValues, [name]: value });
    if (name === "countryId") {
      getStateList(value);
      country.find((info) => {
        if (info.id == value) {
          setUpdateCountry(info.name);
        }
      });
    }

    if (name === "stateId") {
      getCitList(value);
      setUpdateCity("");
      setFormValues({ ...formValues, stateId: value, cityId: "" });
      state.find((info) => {
        if (info.id == value) {
          setUpdateState(info.name);
        }
      });
    }
    if (name === "zone") {
      zoneList.find((info) => {
        if (info.zoneId == value) {
          setZoneEnterprise(info.enterprise);
          // formValues.zoneEnterprise = info.enterprise
        }
      });
    }
    if (name === "cityId") {
      city.find((info) => {
        if (info.id == value) {
          setUpdateCity(info.name);
        }
      });
    }

    if (e.target.name == "zipCode") {
      // getStateRequestId(e.target.value)
      setFormValues({ ...formValues, [name]: value.replace(/\D/g, "") });
    }
    if (e.target.name === "shortSiteName") {
      setFormValues({
        ...formValues,
        [name]: value.replace(/[^a-zA-Z ]+/g, ""),
      });
    }

    if (e.target.name === "contactNumber") {
      setFormValues({ ...formValues, [name]: value.replace(/\D/g, "") });
    }

    // if (e.target.name == "longitude") {

    //      // getStateRequestId(e.target.value)
    //      setFormValues({ ...formValues, [name]: value.replace(/\D/g, '') });
    //     }

    //   if (e.target.name == "latitude") {

    //        // getStateRequestId(e.target.value)
    //        setFormValues({ ...formValues, [name]: value.replace(/\D/g, '') });
    //       }
  };
  const handleDateChange = (e) => {
    if (e) {
      setFormValues({ ...formValues, commissionedOn: new Date(e) });
    } else {
      setFormValues({ ...formValues, commissionedOn: "" });
    }
  };

  const routeChange = (e) => {
    history.push({
      pathname: "/Assets",
      state: { table: 1, compomentRenderType: "view" },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);
    if (Object.values(result).every((x) => x === "")) {
      if (
        formValues.siteStatus === "FAULT" ||
        formValues.siteStatus === "UNDERMAINTENANCE" ||
        formValues.siteStatus === "OFFLINE" ||
        formValues.siteStatus === "UPCOMING"
      )
        formValues.isActive = false;
      if (action === "Update") {
        if (formValues.zone) {
          zoneList.find((info) => {
            if (info.zoneId == formValues.zone) {
              formValues.zoneEnterprise = info.enterprise;
            }
          });
        }
        utcTime =
          moment(formValues.commissionedOn).format("YYYY-MM-DDTHH:mm:ss.SSS") +
          "Z";
        const requestParams = {
          site: {
            isActive: formValues.isActive,
            externalId: formValues.externalId,
            shortSiteName: formValues.shortSiteName,
            address1: formValues.addressLine1.replace(/^\s+|\s+$/gm, ""),
            address2: formValues.addressLine2.replace(/^\s+|\s+$/gm, ""),
            cityId: Number(formValues.cityId),
            city: formValues.city,
            contactPersonName: formValues.username.replace(/^\s+|\s+$/gm, ""),
            contactPersonNumber: formValues.contactNumber,
            country: updateCountry,
            countryId: formValues.countryId,
            state: updateState,
            stateId: formValues.stateId,
            city: updateCity,
            cityId: formValues.cityId,
            pinCode: formValues.zipCode,
            stateId: Number(formValues.stateId),
            name: formValues.siteName.replace(/^\s+|\s+$/gm, ""),
            logitude: Number(formValues.longitude),
            latitude: Number(formValues.latitude),
            status: formValues.siteStatus,
            zoneId: Number(formValues.zone),
            commissionedOn: utcTime,
            id: Number(updateSiteId),
            openingTime: moment(formValues.openingTime).format("HH:mm:ss"),
            closingTime: moment(formValues.closingTime).format("HH:mm:ss"),
            workingDays: formValues.workingDays,
            // createdAt: new Date(),
          },
          zoneEnterprise: formValues.zoneEnterprise,
        };
        try {
          putRequest(`bss/site/update?enterprise=${enterprise}`, requestParams)
            .then((res) => {
              if (res.data != null) {
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                history.push({
                  pathname: "/Assets",
                  state: { table: 1, compomentRenderType: "view" },
                });
              }
            })
            .catch((err) => {
              notificationService.showNonBlacklistedError(
                err?.config?.url,
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Please try again later."
              );
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        utcTime =
          moment(formValues.commissionedOn).format("YYYY-MM-DDTHH:mm:ss.SSS") +
          "Z";
        const requestParams = {
          site: {
            isActive: formValues.isActive,
            externalId: formValues.externalId,
            shortSiteName: formValues.shortSiteName,
            address1: formValues.addressLine1.replace(/^\s+|\s+$/gm, ""),
            address2: formValues.addressLine2.replace(/^\s+|\s+$/gm, ""),
            cityId: Number(formValues.cityId),
            city: formValues.city,
            contactPersonName: formValues.username.replace(/^\s+|\s+$/gm, ""),
            contactPersonNumber: formValues.contactNumber,
            country: updateCountry,
            countryId: formValues.countryId,
            state: updateState,
            stateId: formValues.stateId,
            city: updateCity,
            cityId: formValues.cityId,
            pinCode: formValues.zipCode,
            stateId: Number(formValues.stateId),
            name: formValues.siteName.replace(/^\s+|\s+$/gm, ""),
            logitude: Number(formValues.longitude),
            latitude: Number(formValues.latitude),
            status: formValues.siteStatus,
            zoneId: Number(formValues.zone),
            commissionedOn: utcTime,
            createdAt: new Date(),
            openingTime: moment(formValues.openingTime).format("HH:mm:ss"),
            closingTime: moment(formValues.closingTime).format("HH:mm:ss"),
            workingDays: formValues.workingDays,
          },
          zoneEnterprise: zoneEnterprise,
        };
        try {
          postRequest("bss/site/addSite", requestParams)
            .then((res) => {
              if (res.data != null) {
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                history.push({
                  pathname: "/Assets",
                  state: { table: 1 },
                });
              }
            })
            .catch((err) => {
              notificationService.showNonBlacklistedError(
                err?.config?.url,
                err?.response?.data?.message
                  ? err?.response?.data?.message
                  : "Please try again later."
              );
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};
    if (!formValues.siteName.replace(/\s/g, "").length) {
      errors.siteName = "Site Name is required!";
    } else if (!/^[ A-Za-z0-9-_.&']*$/i.test(formValues.siteName)) {
      errors.siteName = "-_&. are the only allowed special characters!";
    } else {
      errors.siteName = "";
    }

    if (!formValues.username.replace(/\s/g, "").length) {
      errors.username = "Contact Person Name is required!";
    } else if (!/^[A-Z a-z]+$/i.test(formValues.username)) {
      errors.username = "Please enter a valid name(only alphabets)!";
    } else {
      errors.username = "";
    }
    if (!formValues.contactNumber) {
      errors.contactNumber = "Contact Number is required!";
    } else if (formValues.contactNumber.length !== 10) {
      errors.contactNumber =
        "This is not a valid contact number, required 10 digits";
    } else {
      errors.contactNumber = "";
    }
    if (!formValues.latitude && formValues.latitude !== 0) {
      errors.latitude = "Latitude is required!" + formValues.latitude;
    } else if (
      !/^-?([0-8]?[0-9]|90)(\.[0-9]{1,10})?$/i.test(formValues.latitude)
    ) {
      errors.latitude = "Please enter a valid latitude";
    } else {
      errors.latitude = "";
    }

    if (!formValues.longitude && formValues.longitude !== 0) {
      errors.longitude = "Longitude is required!";
    } else if (
      !/^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})?$/i.test(
        formValues.longitude
      )
    ) {
      errors.longitude = "Please enter a valid longitude ";
    } else {
      errors.longitude = "";
    }

    if (!formValues.addressLine1.replace(/\s/g, "").length) {
      errors.addressLine1 = "Address is required!";
    } else if (!/^[ A-Za-z0-9_./#@&+\-,]*$/i.test(formValues.addressLine1)) {
      errors.addressLine1 =
        "Only Accept alphanumeric and some special character .&#@/,-";
    } else {
      errors.addressLine1 = "";
    }

    if (formValues.addressLine2.replace(/\s/g, "").length) {
      errors.addressLine2 = "Address is required!";
    }
    if (!/^[ A-Za-z0-9_./#@&+\-,]*$/i.test(formValues.addressLine2)) {
      errors.addressLine2 =
        "Only Accept alphanumeric and some special character .&#@/,-";
    } else {
      errors.addressLine2 = "";
    }

    if (!formValues.cityId || formValues.cityId == -1) {
      errors.city = "City is required!";
    }
    //  else if (!/^[A-Z a-z]+$/i.test(formValues.city)) {
    //   errors.city = "Please enter a valid city name!";
    // }
    else {
      errors.city = "";
    }

    if (!formValues.stateId || formValues.stateId == -1) {
      errors.state = "State is required!";
    }
    // else if (!/^[A-Z a-z]+$/i.test(formValues.state)) {
    //   errors.state = "Please a valid state name!";
    // }
    else {
      errors.state = "";
    }

    if (!formValues.zipCode) {
      errors.zipCode = "Zip code is required!";
    } else if (formValues.zipCode.length !== 6) {
      errors.zipCode = "This is not a valid zip code, required 6 digits";
    } else {
      errors.zipCode = "";
    }

    if (!formValues.zone || formValues.zone === "-1") {
      errors.zone = "Zone is required!";
    } else {
      errors.zone = "";
    }

    if (formValues.countryId == -1) {
      errors.country = "Country is required!";
    } else {
      errors.country = "";
    }

    if (!formValues.siteStatus || formValues.siteStatus === "-1") {
      errors.siteStatus = "Site Status is required!";
    } else {
      errors.siteStatus = "";
    }

    if (
      formValues.swapStations &&
      (!Number.isInteger(Number(formValues.swapStations)) ||
        Number(formValues.swapStations) < 0)
    ) {
      errors.swapStations = "Please enter positive integer";
    } else {
      errors.swapStations = "";
    }
    if (!formValues.commissionedOn) {
      errors.commissionedOn = "Please select appropriate date!";
    }

    if (formValues.openingTime === null) {
      errors.openingTime = "Opening Time is required!";
    } else {
      errors.openingTime = "";
    }

    if (formValues.closingTime === null) {
      errors.closingTime = "Closing Time is required!";
    } else {
      errors.closingTime = "";
    }

    if (
      !formValues.workingDays ||
      formValues.workingDays === null ||
      formValues.workingDays?.length === 0
    ) {
      errors.workingDays = "Working Days is required!";
    } else {
      errors.workingDays = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  return (
    <>
      <h2
        id="AddSite_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Site"}
      </h2>

      <form id="AddSite_Form">
        <div
          id="AddSite_Form_layout"
          className={cn(styles.group, styles.group_layout)}
        >
          <div
            id="AddSite_Form_layout1"
            className={cn(styles.flex3, styles.flex3_layout)}
          >
            <h3
              id="AddSite_Form_title"
              className={cn(styles.subtitle, styles.subtitle_layout)}
            >
              {title}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div
              id="AddSite_Form_row1"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_SiteName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_SiteName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_SiteName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site Name *"}
                  </div>

                  <input
                    id="AddSite_SiteName_input"
                    type="text"
                    name="siteName"
                    // placeholder="skdfjsldkfj"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.siteName}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="50"
                    // required
                  />
                </div>
                <p>{formErrors.siteName}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddSite_ContactPersonName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_ContactPersonName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_ContactPersonName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Contact Person Name*"}
                  </div>
                  <input
                    id="AddSite_ContactPersonName_input"
                    type="text"
                    name="username"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.username}
                    onChange={handleChange}
                    maxLength="50"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.username}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row2"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_ShortSiteName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_ShortSiteName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_ShortSiteName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Short Site Name "}
                  </div>

                  <input
                    id="AddSite_ShortSiteName_input"
                    type="text"
                    name="shortSiteName"
                    // placeholder="skdfjsldkfj"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.shortSiteName}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="20"
                    // required
                  />
                </div>
                <p>{formErrors.shortSiteName}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddSite_ExternalId_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_ExternalId"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_ExternalId_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"External Id "}
                  </div>
                  <input
                    id="AddSite_ExternalId_input"
                    type="number"
                    name="externalId"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.externalId}
                    onChange={handleChange}
                    maxLength="10"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.externalId}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row3"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_ContactNumber_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_ContactNumber"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_ContactNumber_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Contact Number*"}
                  </div>
                  <input
                    id="AddSite_ContactNumber_input"
                    type="text"
                    name="contactNumber"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.contactNumber}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="10"
                  />
                </div>
                <p>{formErrors.contactNumber}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddSite_SiteAddress1_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_SiteAddress1"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_SiteAddress1_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site Address 1*"}
                  </div>
                  <input
                    id="AddSite_SiteAddress1_input"
                    type="text"
                    name="addressLine1"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.addressLine1}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="250"
                  />
                </div>
                <p>{formErrors.addressLine1}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row4"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_SiteAddress2_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_SiteAddress2"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_SiteAddress2_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site Address 2"}
                  </div>
                  <input
                    id="AddSite_SiteAddress2_input"
                    type="text"
                    name="addressLine2"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.addressLine2}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength="250"
                  />

                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}

                  {/* <select
                    name="city"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.city}
                    onChange={handleChange}
                    disabled={onlyView || action === "Update"}
                    required
                  >
                    <option value="-1"></option>
                    {city.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select> */}
                </div>
                <p>{formErrors.addressLine2}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />

              <div id="AddSite_Country_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_Country"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_Country_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Country*"}
                  </div>
                  <select
                    id="AddSite_Country_select"
                    name="countryId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.countryId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Country</option>
                    {country.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.country}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row5"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddSite_State_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_State"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_State_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"State*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}

                  <select
                    id="AddSite_State_select"
                    name="stateId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.stateId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1">Select State</option>
                    {state.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.state}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="AddSite_City_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_City"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_City_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"City*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}

                  <select
                    id="AddSite_City_select"
                    name="cityId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.cityId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1">Select City</option>
                    {city.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.city}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row6"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddSite_ZipCode_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_ZipCode"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_ZipCode_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Zip Code*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                  <input
                    id="zipcodevalue"
                    type="text"
                    name="zipCode"
                    maxLength="6"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.zipCode}
                    onChange={handleChange}
                    disabled={onlyView}
                    pattern="[0-9.]+"
                  />
                </div>
                <p>{formErrors.zipCode}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div id="AddSite_Zone_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_Zone"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_Zone_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Zone*"}
                  </div>
                  <select
                    id="AddSite_Zone_select"
                    name="zone"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.zone}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1">Select zone</option>
                    {zoneList.map((obj) => {
                      return <option value={obj.zoneId}>{obj.zone}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.zone}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row7"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_Latitude_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_Latitude"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_Latitude_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Latitude*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                  <input
                    id="AddSite_Latitude_input"
                    type="text"
                    name="latitude"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.latitude}
                    onChange={handleChange}
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.latitude}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />

              <div
                id="AddSite_Longitude_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_Longitude"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_Longitude_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Longitude*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                  <input
                    id="AddSite_Longitude_input"
                    type="text"
                    name="longitude"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.longitude}
                    onChange={handleChange}
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.longitude}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row8"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddSite_WorkingHours" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_WorkingHours_block"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_WorkingHours_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Working Hours"}
                    <div
                      id="AddSite_WorkingHours_openingTime_label"
                      className={cn(styles.text_body2, styles.text_body_layout)}
                    >
                      {"From Time*"}
                    </div>
                  </div>
                  <TimePicker
                    value={formValues.openingTime}
                    // value={moment().hours(13).minute(1)}
                    onChange={(val) => handleTime("openingTime", val)}
                    showSecond={false}
                    allowEmpty
                  />

                  <p>{formErrors.openingTime}</p>

                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    id="AddSite_WorkingHours_totime_block"
                    className={cn(styles.block3, styles.block3_layout)}
                  >
                    <div
                      id="AddSite_WorkingHours_totime_label"
                      className={cn(styles.text_body2, styles.text_body_layout)}
                    >
                      {"To Time*"}
                    </div>
                    <TimePicker
                      value={formValues.closingTime}
                      onChange={(val) => handleTime("closingTime", val)}
                      showSecond={false}
                      allowEmpty
                    />
                  </div>
                  <p>{formErrors.closingTime}</p>
                </div>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="AddSite_WorkingDays" className={cn(styles.flex2_item)}>
                <div
                  id="AddSite_WorkingDays_block"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_WorkingDays_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Working Days*"}
                  </div>

                  <FormGroup row>
                    {days.map((day, i) => {
                      return (
                        <FormControlLabel
                          onChange={() => handleWorkingDays(i)}
                          control={
                            <Checkbox
                              checked={formValues.workingDays?.includes(i)}
                            />
                          }
                          label={day}
                        />
                      );
                    })}
                  </FormGroup>
                </div>
                <p>{formErrors.workingDays}</p>
              </div>
            </div>

            <div
              id="AddSite_Form_row9"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddSite_SiteStatus_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_SiteStatus"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_SiteStatus_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site Status*"}
                  </div>
                  {/* <hr className={cn(styles.line1, styles.line1_layout)} /> */}
                  <select
                    id="AddSite_SiteStatus_select"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    type="select"
                    name="siteStatus"
                    value={formValues.siteStatus}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Status</option>
                    <option value="COMMISSIONED">Commissioned</option>
                    <option value="OFFLINE">Offline</option>
                    <option value="UNDERMAINTENANCE">Under Maintenance</option>
                    <option value="UPCOMING">Upcoming</option>
                    <option value="PRIVATE">Private</option>
                    <option value="PUBLIC">Public</option>
                  </select>
                </div>
                <p>{formErrors.siteStatus}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddSite_CommissionedOn_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddSite_CommissionedOn"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddSite_CommissionedOn_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Commissioned On*"}
                  </div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="CommissionedOn"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      maxDate={new Date()}
                      value={formValues.commissionedOn}
                      onChange={(date) => handleDateChange(date)}
                      renderInput={(params) => <TextField {...params} />}
                      InputProps={{
                        disableUnderline: true,
                        style: { borderBottom: "2px solid rgb(175,180,197)" },
                      }}
                      disabled={onlyView}
                    />
                  </LocalizationProvider>
                </div>
                <p>{formErrors.commissionedOn}</p>
              </div>
            </div>

            <div
              id="AddSite_Button_view"
              className={cn(styles.flex9, styles.flex9_layout)}
            >
              <div id="AddSite_Button_block" className={cn(styles.flex9_item)}>
                {
                  <div
                    id="AddSite_CancelButton"
                    className={cn(styles.block7, styles.block7_layout)}
                    onClick={routeChange}
                  >
                    <h5
                      id="AddSite_CancelButton_title"
                      className={cn(
                        styles.highlights1,
                        styles.highlights1_layout
                      )}
                    >
                      {action === "View" ? "Back" : "Cancel"}
                    </h5>
                  </div>
                }
              </div>
              <div className={cn(styles.flex9_spacer)} />
              {action !== "View" && (
                <div
                  id="AddSite_submitButton"
                  className={cn(styles.flex9_item)}
                  onClick={handleSubmit}
                >
                  <div
                    id="AddSite_submitButton_block"
                    className={cn(styles.block9, styles.block9_layout)}
                  >
                    <h5
                      id="AddSite_submitButton_title"
                      className={cn(
                        styles.highlights2,
                        styles.highlights2_layout
                      )}
                    >
                      {action}
                    </h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default function AddSite(props) {
  return (
    <>
      <Master opts={props} screen={AddSiteForm} showStatus={false} />
    </>
  );
}

AddSite.inStorybook = true;
